import { useState } from 'react';
import { Button } from '@/components';
import { Tooltip } from '@bfe/moly';
import { HelpIcon } from '@bfe/moly-icons';
import { Modal } from '@web3/base-components';
import { useFm, useParams } from '@web3/base-hooks';
import { useProjectData } from '@/containers/aidol/hooks';
import {
  justFormatNumber,
  hybirdOpen,
  isApp,
  openLink,
  isMobile,
  triggerOneLink,
} from '@web3/base-utils';
import { commonOepn } from '@/utils';
import { YestdayPoints } from '../yestdayPoints';
import { PromotionStatus } from '@/types/project';
import { scTrack, WEB3_EVENT } from '@web3/base-tracking';
import { Page } from '@/config/track-config';

import styles from './index.module.scss';

interface Props {
  show: boolean;
  onClose: (isScroll?: boolean) => void;
}

export const PointsModal = (props: Props) => {
  const { show, onClose } = props;
  const [showYestdayPointsModal, setShowYestdayPointsModal] = useState(false);
  const { projectData } = useProjectData();
  const { locale } = useParams();
  const fm = useFm();

  const isNotAdvanced = projectData.status === PromotionStatus.NO;

  return (
    <Modal
      open={show}
      onCancel={onClose}
      footer={null}
      size="medium"
      modal={false}
      direction={!isMobile ? 'center' : 'bottom'}
      title={fm('projectVotingPoints', {
        projectName: projectData.name,
      })}
    >
      <div className={styles.container}>
        <div className={styles.pointArea}>
          <div className={styles.pointTitle}>{fm('totalPoints')}</div>
          <div className={styles.pointValue}>
            <div
              className={isNotAdvanced && styles.notAdvancedPoint}
            >{`${justFormatNumber(projectData.point)}`}</div>
            {isNotAdvanced && (
              <div className={styles.notAdvanced}>{fm('notAdvanced')}</div>
            )}
          </div>
        </div>
        <div className={styles.pointDesc}>
          {/* (may experience delays) */}
          {`* ${fm('updatedEveryMins', { amount: '20' })}`}
        </div>
        <div className={styles.line}></div>
        <div className={styles.task}>
          <div className={styles.taskLabel}>
            <div className={styles.taskLabelTitle}>
              {fm('votingPointsSupporters')}
              <Tooltip title={fm('pointsFromSup')} placement="top">
                <HelpIcon className={styles.helpIcon} />
              </Tooltip>
            </div>
            <div
              className={styles.taskLabelValue}
            >{`${justFormatNumber(projectData.taskPoint)}`}</div>
          </div>
          <Button
            className={styles.button}
            size="small"
            disabled={isNotAdvanced}
            variant={projectData.taskStatus ? 'secondary' : 'secondaryBrand'}
            onClick={() => {
              scTrack(WEB3_EVENT.Web3UserClick, {
                page_name: Page.DeailPage,
                spmName: projectData.name,
                button_name: 'Points1Go',
              });
              onClose(true);
            }}
          >
            {projectData.taskStatus ? fm('completed') : fm('start')}
          </Button>
        </div>
        <div className={styles.line}></div>
        <div className={styles.task}>
          <div className={styles.taskLabel}>
            <div className={styles.taskLabelTitle}>
              {fm('socialMediaPoints')}
              <Tooltip
                title={fm('currentProjectSocMedActScoreWeeklyUpdate')}
                placement="top"
              >
                <HelpIcon className={styles.helpIcon} />
              </Tooltip>
            </div>
            <div
              className={styles.taskLabelValue}
            >{`${justFormatNumber(projectData.initPoint)}`}</div>
          </div>
          <Button
            className={styles.button}
            size="small"
            variant="secondaryBrand"
            onClick={() => {
              commonOepn(
                'https://announcements.bybit.com/en/article/-bybit-ai-dol-superstar-get-your-ai-project-involved-and-get-ready-to-shine--bltf73774b170231b33/?cid=1890329579898277888'
              );
              scTrack(WEB3_EVENT.Web3UserClick, {
                page_name: Page.DeailPage,
                spmName: projectData.name,
                button_name: 'SocialMedia',
              });
            }}
          >
            {fm('readMore')}
          </Button>
        </div>
        <div className={styles.line}></div>
        <>
          <div className={styles.task}>
            <div className={styles.taskLabel}>
              <div className={styles.taskLabelTitle}>
                {/* {fm('pointsFromBounty')} */}
                {fm('mentorsVotingPoints')}
                <Tooltip
                  title={fm('aiAgentsSupportAnnouncementDetails')}
                  placement="top"
                >
                  <HelpIcon className={styles.helpIcon} />
                </Tooltip>
              </div>
              <div className={styles.taskLabelValue}>
                {projectData.hidePoint
                  ? justFormatNumber(projectData.hidePoint)
                  : '0'}
              </div>
            </div>
            <Button
              className={styles.button}
              size="small"
              variant="secondaryBrand"
              onClick={() => {
                commonOepn(
                  'https://announcements.bybit.com/en/article/-bybit-ai-dol-superstar-get-your-ai-project-involved-and-get-ready-to-shine--bltf73774b170231b33/?cid=1890329579898277888'
                );
                scTrack(WEB3_EVENT.Web3UserClick, {
                  page_name: Page.DeailPage,
                  spmName: projectData.name,
                  button_name: 'Mentors',
                });
              }}
            >
              {fm('readMore')}
            </Button>
          </div>
          <div className={styles.line}></div>
        </>
      </div>
      <YestdayPoints
        show={showYestdayPointsModal}
        onClose={() => {
          setShowYestdayPointsModal(false);
        }}
      />
    </Modal>
  );
};
